angular.module("Main").controller("OnlineSalesZusatztarifeController", ["$scope", "$q", "$translate", "$window", "BookingService",
    function ($scope, $q, $translate, $window, BookingService) {
        let vm = this;
        vm.parent = $scope.$parent.vm;
        vm.angebot = vm.parent.angebot;
        vm.layoutColors = vm.parent.layoutColors;
        vm.selectedMember = vm.parent.selectedMember;
        vm.selectedMembership = vm.parent.selectedMembership;
        vm.selectedMembershipAdds = vm.parent.selectedMembershipAdds;
        vm.selectedMembershipId = vm.parent.surveyId;
        vm.onlineSalesConfig = vm.parent.onlineSalesConfig;
        vm.beginZT = 0;
        vm.limitLengthZT = vm.parent.limitLengthZT;
        vm.pflichtGebuehren = [];
        vm.pflichtGebuehrenOrig = [];
        vm.selectedAdditionsPauschalen = vm.parent.selectedAdditionsPauschalen ? vm.parent.selectedAdditionsPauschalen : (vm.parent.SelectedAdditionsPauschalen ? vm.parent.SelectedAdditionsPauschalen : []);
        vm.selectedAdditionsPauschalenIds = vm.parent.selectedAdditionsPauschalenIds ? vm.parent.selectedAdditionsPauschalenIds : [];
        vm.selectedAdditionsGebuehrenIds = vm.parent.selectedAdditionsGebuehrenIds ? vm.parent.selectedAdditionsGebuehrenIds : [];
        vm.selectedAdditionsGebuehren = vm.parent.selectedAdditionsGebuehren ? vm.parent.selectedAdditionsGebuehren : (vm.parent.SelectedAdditionsGebuehren ? vm.parent.SelectedAdditionsGebuehren : []);
        vm.choosenNewangebotForMember = vm.parent.choosenNewangebotForMember;
        vm.pflichtZusatztarifePreis = vm.parent.pflichtZusatztarifePreis;
        vm.selectedAdditionsGesamt = vm.parent.selectedAdditionsGesamt;
        vm.summeMitgliedschaft = 0;
        vm.pflichtZusatztarife = [];
        vm.sizeGebuehrenUndPauschalen = [];
        vm.choosenMembershipIndex = vm.parent.choosenMembershipIndex;
        vm.member = {};
        vm.today = moment().startOf("day").toDate();
        vm.showFormular = true;
        vm.privacyterms = false;
        vm.wdr = false;
        vm.selectedMembership.Inklusiv = [];
        vm.selectedMembership.Vertragsbeginn = moment().startOf("day").toDate();
        vm.hasZusatztarifWithPrice = false;
        vm.hasPauschalenWithPrice = false;
        vm.hasGebuehrenWithPrice = false;
        vm.selectedAdditions = vm.parent.selectedAdditions;
        vm.selectedAdditionsGesamt = vm.parent.selectedAdditionsGesamt;
        vm.selectedAdditionsIds = vm.parent.selectedAdditionsIds ? vm.parent.selectedAdditionsIds : [];
        vm.isSelectedSurvey = vm.parent.isSelectedSurvey;
        vm.locationMembershipBuy = false;
        vm.groupedPricesSurveys = [];
        vm.basistarif = [];
        vm.groupedPricesWithoutBasistarif = [];
        vm.concatAdditionsAndExtraWithoutBasistarif = [];
        vm.groupedPricesGebuehrenPauschalen = [];
        vm.selectedMembershipZTToSelect = {};
        vm.selectedMembershipGebuehrenToSelect = {};
        vm.groupedZusatzleistungen = [];
        vm.cycleUnits = BookingService.getCycleUnits();
        vm.selectedPauschalenWithMembershipZyklus = vm.parent.selectedPauschalenWithMembershipZyklus;
        vm.selectedPauschalenWithMembershipZyklusIds = vm.parent.selectedPauschalenWithMembershipZyklusIds;
        vm.selectedMembershipGebuehrenToSelect = vm.parent.selectedMembershipGebuehrenToSelect;
        vm.selectedMembershipPauschalenToSelect = vm.parent.selectedMembershipPauschalenToSelect;

        vm.basistarif = [{
            Bezeichnung: 'Basistarif',
            price: vm.selectedMembership.Preis,
            zahlzyklus: vm.selectedMembership.ZahlzyklusName
        }];
        vm.selectedAdditionsGesamtUndBasistarif = vm.selectedAdditionsGesamt ? (vm.basistarif[0].price + vm.selectedAdditionsGesamt) : vm.basistarif[0].price;

        var pg = {};


        function parseCycles(value, unit) {
            // if (!value || !unit)
            //     return "";

            if (value === 0)
                return $translate.instant("T_einmalig");

            return ((value > 1) ? value + "-" : "") + $translate.instant(vm.cycleUnits[unit][2]);
        }

        getPreise();

        async function getPreise() {
            try {
                await getAllPreise()
                await getPflichtPreise()
            } catch (error) {

            }
        }

        function getPflichtPreise() {
            vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.pflichtGebuehrenOrig);
            vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
            _.forEach(vm.pflichtGebuehren, function (g) {
                g.gesamt = _.sumBy(g, 'price');
                g.zahlzyklusName = g[0].zahlzyklus
            });

        }

        function getAllPreise() {

            if (vm.selectedMembership.Prices.Zusatztarifpreise) {
                _.forEach(vm.selectedMembership.Prices.Zusatztarifpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Zusatztarife, {'Id': k}));
                    if (f) {
                        if (v === 0) {
                            vm.selectedMembership.Inklusiv.push({
                                Bezeichnung: f.Bezeichnung,
                                Sortierung: f.Sortierung,
                                Reihenfolge: 1
                            });
                        }
                    }
                });
            }
            if (vm.selectedMembership.Prices.Pauschalenpreise) {
                _.forEach(vm.selectedMembership.Prices.Pauschalenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Pauschalen, {'Id': k}));
                    if (f) {
                        if (v === 0) {
                            vm.selectedMembership.Inklusiv.push({
                                Bezeichnung: f.Bezeichnung,
                                Sortierung: f.Sortierung,
                                Reihenfolge: 3
                            });
                        }
                    }
                });
            }
            if (vm.selectedMembership.Prices.Gebuehrenpreise) {
                _.forEach(vm.selectedMembership.Prices.Gebuehrenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Gebuehren, {'Id': k}));
                    if (f) {
                        if (v === 0) {
                            vm.selectedMembership.Inklusiv.push({
                                Bezeichnung: f.Bezeichnung,
                                Sortierung: f.Sortierung,
                                Reihenfolge: 2
                            });
                        }
                    }
                });
            }


            if (vm.selectedMembership.Prices.Pauschalenpreise) {
                _.forEach(vm.selectedMembership.Prices.Pauschalenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Pauschalen, {'Id': k}));
                    // vm.pauschalenZyklen[k] = parseCycles(f.Zyklus, f.Zykluseinheit);

                    if (f) {
                        if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehren.push({
                                Bezeichnung: f.Bezeichnung,
                                price: v,
                                zahlzyklus: vm.selectedMembershipAdds.Pauschalen[k].Zahlzyklus
                            });
                        }
                    }
                });
            }
            if (vm.selectedMembership.Prices.Gebuehrenpreise) {
                _.forEach(vm.selectedMembership.Prices.Gebuehrenpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Gebuehren, {'Id': k}));
                    if (f) {
                        if (v > 0 && f.Option === 3) {
                            vm.pflichtGebuehren.push({Bezeichnung: f.Bezeichnung, price: v, zahlzyklus: 'einmalig'});
                        }
                        else if (f.Option !== 3 && v > 0) {
                            vm.selectedMembershipGebuehrenToSelect[k] = f;
                        }
                    }
                });
            }
            if (vm.selectedMembership.Prices.Zusatztarifpreise) {
                _.forEach(vm.selectedMembership.Prices.Zusatztarifpreise, function (v, k) {
                    let f = (_.find(vm.selectedMembershipAdds.Zusatztarife, {'Id': k}));
                    if (f) {
                        if (v > 0 && f.Option === 3) {
                            vm.pflichtZusatztarifePreis = vm.pflichtZusatztarifePreis + v;
                            vm.pflichtZusatztarife.push({
                                Bezeichnung: f.Bezeichnung,
                                price: v,
                                zahlzyklus: vm.selectedMembershipAdds.Zusatztarife[k].Zahlzyklus
                            });
                        }
                        else if (f.Option !== 3 && v > 0) {
                            vm.selectedMembershipZTToSelect[k] = f;
                        }
                    }
                });
            }


            _.forEach(vm.selectedAdditions, function (s) {
                s.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
                _.find(vm.selectedMembershipZTToSelect, {'Id':s.Id}).BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
            })

        }

        vm.groupedPricesSurveys = _.groupBy((_.concat(vm.basistarif, vm.pflichtGebuehren)), 'zahlzyklus');
        _.forEach(vm.groupedPricesSurveys, function (g) {
            g.gesamt = _.sumBy(g, 'price');
            g.zahlzyklusName = g[0].zahlzyklus;
            g.Bezeichnung = g[0].name;
        });

        var findSurvey = _.find(vm.membershipsOptions, {
            'Mitgliedschaft_Id': vm.selectedMembershipId,
            'Mandant_Id': vm.selectedMandantNr,
            'Laufzeit': vm.selectedMembership.Laufzeit,
            'LaufzeitEinheit': vm.selectedMembership.Laufzeiteinheit,
            'Zahlzyklus': vm.selectedMembership.Zahlzyklus,
            'ZahlzyklusEinheit': vm.selectedMembership.ZahlzyklusEinheit
        });
        if (findSurvey) {
            vm.findSurvey = findSurvey;
            vm.resultZT = findSurvey.Zusatztarife_Step_Online;
            vm.resultZL = findSurvey.Zusatzleistungen_Step_Online;
        }
        _.forEach(vm.selectedMembership.Prices.Zusatztarifpreise, function (zt) {
            if (zt > 0) {
                vm.hasZusatztarifWithPrice = true;
            }
        });
        vm.zusatztarifenWithPrice = (_.countBy(vm.selectedMembership.Prices.Zusatztarifpreise, function (p) {
            return p > 0;
        }));

        if (vm.zusatztarifenWithPrice["true"]) {
            vm.countZusatztarifePrices = vm.zusatztarifenWithPrice["true"]
        } else {
            vm.countZusatztarifePrices = 0;
        }

        _.forEach(vm.selectedMembership.Prices.Gebuehrenpreise, function (v, k) {
            let f = (_.find(vm.selectedMembershipAdds.Gebuehren, {'Id': k}));
            if (f) {
                if (v > 0 && f.Option !== 3) {
                    vm.hasGebuehrenWithPrice = true;
                }
            }
        });

        vm.pauschalenZyklen = {};
        _.forEach(vm.selectedMembership.Prices.Pauschalenpreise, function (v, k) {
            let f = (_.find(vm.selectedMembershipAdds.Pauschalen, {'Id': k}));
            if (f) {
                vm.pauschalenZyklen[k] = parseCycles(f.Zyklus, f.Zykluseinheit);

                if (v > 0 && f.Option !== 3) {
                    vm.hasPauschalenWithPrice = true;
                }
            }
        });

        if ((vm.hasZusatztarifWithPrice === false || (_.size(vm.selectedMembershipAdds.Zusatztarife) === 0) || (vm.resultZT === 0 && vm.resultZL === 1)) &&
            (vm.hasPauschalenWithPrice === true || vm.hasGebuehrenWithPrice === true)) {
            vm.index = 4;
            vm.hasZusatztarife = false;
            vm.hasZusatzleistungen = true;
        } else if (vm.hasZusatztarifWithPrice === true && ((vm.findSurvey && vm.resultZT === 1) || (!vm.findSurvey && _.size(vm.selectedMembershipAdds.Zusatztarife) > 0))) {
            vm.index = 3;
            vm.hasZusatztarife = true;
        } else {
            vm.index = 5;
            vm.hasZusatztarife = false;
            vm.hasZusatzleistungen = false;
            vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
            _.forEach(vm.pflichtGebuehren, function (g) {
                g.gesamt = _.sumBy(g, 'price');
                g.zahlzyklusName = g[0].zahlzyklus
            });
        }
        vm.gebuehrenWithPrice = (_.countBy(vm.selectedMembership.Prices.Gebuehrenpreise, function (p) {
            return p > 0;
        }))
        vm.pauschalenWithPrice = (_.countBy(vm.selectedMembership.Prices.Pauschalenpreise, function (p) {
            return p > 0;
        }))
        if (vm.gebuehrenWithPrice["true"]) {
            vm.countGebuehrenPrices = vm.gebuehrenWithPrice["true"]
        } else {
            vm.countGebuehrenPrices = 0;
        }
        if (vm.pauschalenWithPrice["true"]) {
            vm.countPauschalenPrices = vm.pauschalenWithPrice["true"]
        } else {
            vm.countPauschalenPrices = 0;
        }
        vm.zusatzleistungenWithPrice = vm.countGebuehrenPrices + vm.countPauschalenPrices;

        vm.currentZT = [];
        for (let i = 0; i < vm.limitLengthZT; ++i) {
            vm.currentZT[i] = vm.selectedMembershipAdds.Zusatztarife[i];
        }

        vm.showMoverZT = vm.countZusatztarifePrices > vm.limitLengthZT;

        vm.groupedPricesWithoutBasistarif = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
        _.forEach(vm.groupedPricesWithoutBasistarif, function (g) {
            g.gesamt = _.sumBy(g, 'price');
            g.zahlzyklusName = g[0].zahlzyklus
        });
        vm.pflichtGebuehrenOrig = vm.pflichtGebuehren;
        vm.summeMitgliedschaft = vm.pflichtZusatztarifePreis ? vm.selectedMembership.Preis + vm.pflichtZusatztarifePreis :
            vm.selectedMembership.Preis;

        if (vm.parent.index === 5) {
            vm.sizeGebuehrenUndPauschalen = _.size(vm.pflichtGebuehren);
        } else {
            vm.sizeGebuehrenUndPauschalen = vm.pflichtGebuehren.length;
        }

        vm.checkAdditions2 = function (addition, price, zahlzyklus) {
            addition.price = price;
            addition.zahlzyklus = zahlzyklus;

            if (vm.selectedAdditions.some(item => item.Id === addition.Id)) {
                addition.BorderColor = 'unset';
                addition = _.find(vm.selectedAdditions, {Id: addition.Id})
                _.pull(vm.selectedAdditions, addition);
                _.pull(vm.selectedAdditionsIds, addition.Id);
            } else {
                addition.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
                vm.selectedAdditions.push(addition);
                vm.selectedAdditionsIds.push(addition.Id);
            }

            let filteredAdd = _.filter(vm.selectedMembershipZTToSelect, { 'Id': addition.Id})
                if(filteredAdd) {
                    filteredAdd.BorderColor = 'unset';
                //addition = _.find(vm.selectedAdditions, {Id: addition.Id})
                _.pull(vm.selectedMembershipZTToSelect, filteredAdd);
            } else {
                    filteredAdd.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
                vm.selectedMembershipZTToSelect.push(filteredAdd);
            }

            vm.selectedAdditionsGesamt = _.sumBy(vm.selectedAdditions, function (o) {
                return o.price;
            });

            vm.selectedAdditionsGesamtUndBasistarif = vm.basistarif[0].price + vm.selectedAdditionsGesamt;

        };

        vm.infoTextAddition = false;
        vm.infoTextExtraAddition = false;
        vm.selectedExtraAdditionsInfo = [];
        vm.selectedAdditionsInfo = [];
        vm.additionsOpenedDetails = false;

        vm.showShopingCard = function () {
            if (vm.openShopingCart === false) {
                vm.openShopingCart = true;
            } else {
                vm.openShopingCart = false
            }
        }

        vm.openAndCloseDetailsAdditions = function () {
            if (vm.additionsOpenedDetails === false) {
                vm.additionsOpenedDetails = true;
            } else
                vm.additionsOpenedDetails = false;
        };

        vm.openInfoTextAddition = function (id, event) {
            event.stopPropagation();
            vm.selectedAdditionsInfo.push(id);
            vm.infoTextAddition[id] = true;
            if (!_.includes(vm.selectedAdditions, id)) {
                vm.selectedAdditions.push(id);
            } else {
                _.pull(vm.selectedAdditions, id);
            }
        };

        vm.closeInfoTextAddition = function (id, event) {
            event.stopPropagation();
            _.pull(vm.selectedAdditionsInfo, id);
            vm.infoTextAddition[id] = false;
            if (!_.includes(vm.selectedAdditions, id)) {
                vm.selectedAdditions.push(id);
            } else {
                _.pull(vm.selectedAdditions, id);
            }
        };

        vm.moveLeftZT = function () {
            vm.chunkedZT = _.chunk(vm.selectedMembershipAdds.Zusatztarife, vm.limitLengthZT);
            vm.lengthChunkedZT = (vm.chunkedZT).length;
            vm.beginZT--;
            if (vm.beginZT < 0) {
                vm.beginZT = vm.lengthChunkedZT;
            }
            vm.currentZT = vm.chunkedZT[vm.beginZT];
        };

        vm.moveRightZT = function () {
            vm.chunkedZT = _.chunk(vm.selectedMembershipAdds.Zusatztarife, vm.limitLengthZT);
            vm.lengthChunkedZT = (vm.chunkedZT).length;
            vm.beginZT++;
            if (vm.beginZT === vm.lengthChunkedZT) {
                vm.beginZT = 0;
            }
            vm.currentZT = vm.chunkedZT[vm.beginZT];
        };

        // Mindestanzahl Zusatzleistungen nur auf diesem Schritt prüfen, wenn danach KEIN
        // Gebühren-/Pauschalen-Schritt mehr folgt (sonst würde der Weiter-Button fälschlich
        // gesperrt, obwohl die restliche Auswahl erst dort erfolgt). Bei nur konfigurierten
        // Zusatztarifen (ohne Gebühren/Pauschalen) geht der Weiter direkt zum Kauf – hier muss
        // die Prüfung greifen, die sonst nur im Gebühren-/Pauschalen-Schritt läuft.
        vm.minZusatzleistungenNichtErreicht = function () {
            if (vm.hasPauschalenWithPrice || vm.hasGebuehrenWithPrice) return false;
            var minZL = vm.parent.minZusatzleistungen || 0;
            if (minZL <= 0) return false;
            var selected = (vm.selectedAdditions ? vm.selectedAdditions.length : 0)
                         + (vm.selectedAdditionsGebuehren ? vm.selectedAdditionsGebuehren.length : 0)
                         + (vm.selectedAdditionsPauschalen ? vm.selectedAdditionsPauschalen.length : 0)
                         + (vm.selectedPauschalenWithMembershipZyklus ? vm.selectedPauschalenWithMembershipZyklus.length : 0);
            return selected < minZL;
        };

        vm.selectExtraAdditions = function (survey, surveyId) {
            if (vm.minZusatzleistungenNichtErreicht()) return;
            vm.parent.selectExtraAdditions(survey, surveyId, vm.hasPauschalenWithPrice, vm.pflichtZusatztarife, vm.hasGebuehrenWithPrice, vm.basistarif,
                vm.pflichtGebuehrenOrig, vm.pflichtGebuehren, vm.selectedAdditions, vm.selectedAdditionsGesamt, vm.selectedMembershipGebuehrenToSelect,
                vm.selectedMembershipAdds.Pauschalen, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds);
        };

        vm.goToSurveys = function () {
            vm.parent.goToSurveys('surveys', vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.choosenNewangebotForMember, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
        }

        vm.goToSurveysAngebot = function () {
           // if(!vm.parent.choosenMemberAngebot && !vm.parent.selectedFoundAngebot) {
                vm.parent.goToSurveysAngebot('surveys', vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.choosenNewangebotForMember,
                    vm.parent.selectedMembership, vm.selectedMembershipAdds,vm.choosenMembershipIndex, vm.selectedAdditions, vm.selectedAdditionsPauschalen,
                    vm.selectedAdditionsGebuehren, vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
           // }
        }

        vm.selectExtraAdditionsAngebot = function () {
            if (vm.minZusatzleistungenNichtErreicht()) return;
            if(vm.hasPauschalenWithPrice || vm.hasGebuehrenWithPrice) {
            vm.parent.goToExtraAdditionsAngebot('extraAdditions',vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.hasZusatzleistungen,
                vm.selectedMembership.HasPauschalenwithPrice, vm.selectedMembership.HasGebuehrenWithPrice, vm.parent.selectedMember, vm.selectedMembership,
                vm.parent.choosenMemberAngebot, vm.parent.selectedFoundAngebot, vm.parent.choosenNewangebotForMember, vm.pflichtZusatztarife,
                vm.selectedAdditions, vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis, vm.selectedMembershipAdds, vm.selectedAdditionsIds,
                vm.selectedAdditionsGebuehrenIds, vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
            } else {
                vm.parent.buyMembership(vm.selectedMembership, vm.selectedMembership.MitgliedschaftsNr, vm.selectedMembership.Basistarif,
                    vm.selectedMembership.Pflichtgebuehren, vm.selectedMembership.SelectedAdditions, vm.selectedMembership.SelectedPauschalen,
                    vm.selectedMembership.SelectedGebuehren, vm.selectedAdditionsGesamt, vm.parent.selectedFoundAngebot, vm.parent.choosenMemberAngebot,
                    vm.parent.selectedAngebot, vm.choosenMemberAngebotDatum, vm.selectedFoundAngebotDatum, vm.choosenNewangebotForMember,
                    vm.pflichtZusatztarife, vm.pflichtZusatztarifePreis, vm.selectedAdditions, vm.pflichtGebuehren, vm.selectedAdditionsPauschalen,
                    vm.selectedAdditionsGebuehren, vm.selectedAdditionsIds,
                    vm.selectedAdditionsGebuehrenIds, vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
            }
        }
    }]);